import axios from 'axios';

export default class LicenseApi {
  constructor(baseUrl, config) {
    this.baseUrl = baseUrl;
    this.config = config;
  }

  postLicenseFile(formData, fiscalYear) {
    const config = {
      ...this.config,
      headers: {
        ...this.config.headers,
        'content-type': 'multipart/form-data',
      },
    };
    //config.headers.Authorization = 'Bearer ' + cookie.getCookie('access_token');
    const url = `${this
      .baseUrl}/api/controlinfo/license?fiscalyear=${fiscalYear}`;

    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, config)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getControlInfoExists() {
    // this.config.headers.Authorization =
    //   'Bearer ' + cookie.getCookie('access_token');
    const url = `${this.baseUrl}/api/controlinfo/1`;

    return new Promise((resolve, reject) => {
      axios
        .get(url, this.config)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/license/api/LicenseApi.js